import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';
import PuntoVentaV2 from './components/PuntoVentaV2';
import Productos from './components/Productos';
import Boletas from './components/Boletas';
import Reportes from './components/Reportes';
import Usuarios from './components/Usuarios';
import LoadingOverlay from './components/LoadingOverlay';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

interface User {
  id_usuario: number;
  nombre_usuario: string;
  nick_usuario: string;
  tipo: number;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay sesión activa
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Error al parsear usuario:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('authToken');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (loggedInUser: User) => {
    setUser(loggedInUser);
  };

  const handleLogout = () => {
    setUser(null);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <LoadingOverlay />
        <Routes>
          <Route 
            path="/login" 
            element={
              user ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />
            } 
          />
          
          <Route 
            path="/dashboard" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <DashboardHome user={user} />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/punto-venta" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <PuntoVentaV2 user={user} />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/productos" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <Productos />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/boletas" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <Boletas />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/boletas/:id" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <Boletas />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/reportes" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <Reportes />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/usuarios" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout}>
                  <Usuarios />
                </Dashboard>
              ) : <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/" 
            element={<Navigate to={user ? "/dashboard" : "/login"} replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
